import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthLayout } from '@/layouts/AuthLayout'
import { AdminLayout } from '@/layouts/AdminLayout'
import { LoginPage } from '@/pages/Login'
import { DashboardPage } from '@/pages/Dashboard'
import { SellersPage } from '@/pages/Sellers'
import { SellerDetailPage } from '@/pages/SellerDetail'
import { TemplatesPage } from '@/pages/Templates'
import { TemplateDetailPage } from '@/pages/TemplateDetail'
import { OptOutKeywordsPage } from '@/pages/OptOutKeywords'
import { PromptsPage } from '@/pages/Prompts'
import { PromptDetailPage } from '@/pages/PromptDetail'
import { PromptHistoryPage } from '@/pages/PromptHistory'
import { PromptDiffPage } from '@/pages/PromptDiff'
import { PromptAssistantPage } from '@/pages/PromptAssistant'
import { CampaignsPage } from '@/pages/Campaigns'
import { CampaignDetailPage } from '@/pages/CampaignDetail'
import { ConversationsPage } from '@/pages/Conversations'
import { ConversationDetailPage } from '@/pages/ConversationDetail'
import { SettingsPage } from '@/pages/Settings'
import { UsersPage } from '@/pages/Users'
import { AuditLogPage } from '@/pages/AuditLog'
import { HealthPage } from '@/pages/Health'
import { VendorCalendarsPage } from '@/pages/VendorCalendars'
import { CarteirasPage } from '@/pages/Carteiras'
import { queryClient } from '@/lib/queryClient'
import { ThemeProvider } from '@/lib/theme'
import { ToastProvider, ToastViewport } from '@/components/ui/toast'
import { TooltipProvider } from '@/components/ui/tooltip'

export function App(): React.ReactElement {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <TooltipProvider delayDuration={200}>
            <BrowserRouter>
              <Routes>
                <Route element={<AuthLayout />}>
                  <Route path="/login" element={<LoginPage />} />
                </Route>
                <Route element={<AdminLayout />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/admin/sellers" element={<SellersPage />} />
                  <Route path="/admin/sellers/new" element={<SellerDetailPage />} />
                  <Route path="/admin/sellers/:id" element={<SellerDetailPage />} />
                  <Route path="/conversations" element={<ConversationsPage />} />
                  <Route path="/admin/conversations" element={<ConversationsPage />} />
                  <Route path="/admin/conversations/:id" element={<ConversationDetailPage />} />
                  <Route path="/admin/templates" element={<TemplatesPage />} />
                  <Route path="/admin/templates/new" element={<TemplateDetailPage />} />
                  <Route path="/admin/templates/:id" element={<TemplateDetailPage />} />
                  <Route path="/admin/opt-out-keywords" element={<OptOutKeywordsPage />} />
                  <Route path="/admin/prompts" element={<PromptsPage />} />
                  <Route path="/admin/prompts/assistant" element={<PromptAssistantPage />} />
                  <Route path="/admin/prompts/:id" element={<PromptDetailPage />} />
                  <Route path="/admin/prompts/:id/history" element={<PromptHistoryPage />} />
                  <Route path="/admin/prompts/:id/history/:version" element={<PromptDiffPage />} />
                  <Route path="/admin/campaigns" element={<CampaignsPage />} />
                  <Route path="/admin/campaigns/new" element={<CampaignDetailPage />} />
                  <Route path="/admin/campaigns/:id" element={<CampaignDetailPage />} />
                  <Route path="/admin/users" element={<UsersPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/admin/audit-log" element={<AuditLogPage />} />
                  <Route path="/admin/health" element={<HealthPage />} />
                  <Route path="/admin/vendor-calendars" element={<VendorCalendarsPage />} />
                  <Route path="/admin/carteiras" element={<CarteirasPage />} />
                </Route>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </BrowserRouter>
            <ToastViewport />
          </TooltipProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export default App
